import React, { useState } from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { LoadingButton } from "@mui/lab";
import skuServices from "app/services/sku-services";
import { downloadBuffer } from "app/utils/appHelpers";
import moment from "moment";

const SKUExportButton = ({
    getExportParams = () => "",
}) => {
    const [exporting, setExporting] = useState(false);

    const exportSkus = async () => {
        try {
            setExporting(true);
            const params = getExportParams();
            const data = await skuServices.exportSkus(params);
            downloadBuffer(data, `skus_export_${moment().format("YYYYMMDDHHmmss")}.xlsx`);
        } catch (_error) {
            // Interceptor handles generic message.
        } finally {
            setExporting(false);
        }
    };

    return (
        <LoadingButton
            loading={exporting}
            variant="contained"
            color="primary"
            size="small"
            endIcon={<FileDownloadOutlinedIcon />}
            disabled={exporting}
            loadingPosition="end"
            onClick={exportSkus}
        >
            {exporting ? "Exportando" : "Exportar Excel"}
        </LoadingButton>
    );
};

export default SKUExportButton;
